// src/mixins/router-mixin.js - 路由导航混入
import { useRouterHelper } from '@/utils/routerHelper'

export default {
  methods: {
    /**
     * 安全的路由跳转 - push
     * @param {string|object} to - 目标路由
     * @param {object} options - 额外选项
     */
    async $navigateTo(to, options = {}) {
      try {
        const helper = useRouterHelper()
        return await helper.push(to, options)
      } catch (error) {
        console.error('Navigation failed:', error)
        return { success: false, error }
      }
    },

    /**
     * 安全的路由跳转 - replace
     * @param {string|object} to - 目标路由
     * @param {object} options - 额外选项
     */
    async $redirectTo(to, options = {}) {
      try {
        const helper = useRouterHelper()
        return await helper.replace(to, options)
      } catch (error) {
        console.error('Redirect failed:', error)
        return { success: false, error }
      }
    },

    /**
     * 构造带语言前缀的路径
     * @param {string} path - 目标路径
     * @param {string} lang - 语言代码（可选）
     */
    $buildPath(path, lang = null) {
      const helper = useRouterHelper()
      return helper.buildPath(path, lang)
    },

    /**
     * 生成 href 链接
     * @param {string} path - 路径
     * @param {object} query - 查询参数
     */
    $buildHref(path, query = {}) {
      const helper = useRouterHelper()
      return helper.buildHref(path, query)
    },

    /**
     * 检查是否为当前路由
     * @param {string} path - 要检查的路径
     */
    $isCurrentRoute(path) {
      const helper = useRouterHelper()
      return helper.isCurrentRoute(path)
    },

    /**
     * 安全的后退
     */
    $goBack() {
      const helper = useRouterHelper()
      helper.goBack()
    },

    /**
     * 刷新当前页面
     */
    $refreshPage() {
      const helper = useRouterHelper()
      helper.refresh()
    },

    /**
     * 切换语言并保持当前路径
     * @param {string} newLang - 新语言代码
     */
    async $switchLanguage(newLang) {
      try {
        const helper = useRouterHelper()
        return await helper.switchLanguage(newLang)
      } catch (error) {
        console.error('Language switch failed:', error)
        return { success: false, error }
      }
    }
  }
}